import BillingV2Adapter from './billing-v2';

export default class SubscriptionPlanAdapter extends BillingV2Adapter {
  pathForType() {
    return 'plans';
  }
}
